import { Button, Input, Modal } from 'antd';
import { useState } from 'react';
import { InviteDowngradePlanModalProps } from '../subscription.types';
import { useTranslation } from 'react-i18next';
import { capitalize } from '@shared/utils/capitalize';

export const DowngradePlanModal = ({
  open,
  hideModal,
  onDowngradeCancelled,
  isCancelled,
  loading,
}: InviteDowngradePlanModalProps) => {
  const { t } = useTranslation();
  const [confirmInput, setConfirmInput] = useState('');
  const [error, setError] = useState('');

  const closeModal = () => {
    hideModal();
    setConfirmInput('');
    setError('');
  };

  const onSubmit = async () => {
    const isMatched = confirmInput === 'CONFIRM';
    if (!isMatched) {
      setError(t('please_enter_correct_characters'));
    } else {
      await onDowngradeCancelled();
      closeModal();
    }
  };

  return (
    <Modal
      className="text-center w-92"
      classNames={{ content: '!max-w-[420px]' }}
      centered
      open={open}
      onCancel={closeModal}
      footer={
        <div className="flex justify-center gap-4">
          <Button className="flex-1 capitalize!" onClick={closeModal}>
            {t('cancel')}
          </Button>
          <Button type="primary" className="flex-1 capitalize!" onClick={onSubmit} loading={loading}>
            {t('confirm')}
          </Button>
        </div>
      }
      zIndex={9999}
    >
      <p className="text-text-900 text-lg font-semibold mb-2">
        {' '}
        {isCancelled ? capitalize(t('reactivate_current_subscription')) : capitalize(t('downgrade_plan_cancellation'))}
      </p>
      <p className="text-text-600 text-sm mb-2">
        {isCancelled
          ? t('are_you_sure_reactivate_your_current_subscription_if_you_add_new_members_subscription_will_restore')
          : t('are_you_sure_you_want_to_continue_will_cancel_your_plan_downgrade_and_restore_your_subscription')}
      </p>

      <div className="mb-4">
        <div className="mb-2">
          <Input value={confirmInput} onChange={(e) => setConfirmInput(e.target.value)} className="w-80 mb-2" />
          <p className="text-red-600">{error}</p>
        </div>
        <p className="text-text-600 text-sm">{t('note_type_confirm_in_the_textbox_to_proceed')}</p>
      </div>
    </Modal>
  );
};
